import React, { useState, useEffect, useRef } from "react";
import { CustomPlaceholder } from ".."; // Ensure the import path is correct
import styles from "./styles.module.scss";

const Dropdown = ({
  options, // Array of options with `label` and `value`
  selectedOption, // Currently selected option (can be an object with `label` and `value`)
  onOptionSelect, // Callback to handle option selection
  defaultText = "Select an option", // Placeholder text if no option is selected
  icon = null // Optional icon for placeholder
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleOptionSelect = (option) => {
    onOptionSelect(option); // Notify parent component of the selected option
    setIsOpen(false); // Close dropdown after selection
  };

  // Close dropdown if click occurs outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); // Close dropdown if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.dropdown} ref={dropdownRef}>
      {/* Dropdown header with CustomPlaceholder */}
      <div className={styles.dropdownHeader} onClick={toggleDropdown}>
        <CustomPlaceholder
          condition={!!selectedOption} // Checks if an option is selected
          text={selectedOption?.label} // Display the selected option's label
          defaultText={defaultText} // Default placeholder text
          icon={icon} // Optional icon (e.g., dropdown icon or any custom icon)
        />
      </div>
      
      {/* Dropdown options list */}
      <ul
        className={`${styles.dropdownList} ${
          isOpen ? styles.visible : styles.hidden
        }`}
      >
        {options.map((option) => (
          <li
            key={option.value} // Each option must have a unique value
            onClick={() => handleOptionSelect(option)} // Handle option selection
            className={styles.dropdownItem}
          >
            {option.label} {/* Display the option label */}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Dropdown;
